import noop from "lodash/noop";

import { MetricCard } from "@similarweb/pro-logic-components";
import { colorsPalettes } from "@similarweb/styles";

import { NO_DATA_SIGN } from "app/filters/const";
import { CardBenchmarkRow } from "app/pages/digital-marketing/generative-ai/llm-tracker/reports/components/CardBenchmarkRow";
import { formatAveragePosition } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/LLMTrackerUtils";
import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";

import { MetricCardSecondary } from "../MetricCardSecondary";
import type { IAveragePositionMetricCardProps } from "../types";
import { getAveragePositionTooltipContent } from "../utils";

export const AveragePositionMetricCard = ({
    averagePosition,
    mentionPositionRank,
    competitorsCount,
    primaryBrand,
    brandAnswers,
    hasData,
    isLoading,
}: IAveragePositionMetricCardProps) => {
    const translate = useTranslation();
    const hasCompetitiveSet = competitorsCount > 0;
    const formattedAveragePosition = formatAveragePosition(averagePosition);
    const formattedMentionPositionRank = mentionPositionRank != null ? `#${mentionPositionRank}` : NO_DATA_SIGN;
    const tooltipContent = getAveragePositionTooltipContent({
        averagePosition,
        mentionPositionRank,
        competitorsCount,
        primaryBrand,
    });

    return (
        <MetricCard
            data-automation="brand-overview-average-position-card"
            title={translate("llm.brand_overview.average_position.title")}
            tooltip={translate(tooltipContent.key, tooltipContent.params)}
            secondaryValue={
                hasData ? (
                    <MetricCardSecondary
                        caption={{
                            textKey: "llm.brand_overview.average_position.text",
                            mentions: brandAnswers,
                        }}
                        benchmark={
                            hasCompetitiveSet ? (
                                <CardBenchmarkRow
                                    label={translate("llm.brand_overview.average_position.rank")}
                                    formattedValue={formattedMentionPositionRank}
                                    valueColor={colorsPalettes.carbon[400]}
                                    dataAutomation="brand-overview-average-position-rank"
                                />
                            ) : null
                        }
                    />
                ) : null
            }
            value={hasData ? formattedAveragePosition : null}
            isLoading={isLoading}
            onCtaClick={noop}
        />
    );
};
